import { defineStore }    from 'pinia'
import { ref, computed }  from 'vue'
import router             from '@/router'
import api, { urls }      from '@/api'

export const useAuthStore = defineStore('auth', () => {
  // State
  const accessToken = ref(localStorage.getItem('accessToken')) 
  const user        = ref(null)

  // api 기본 헤더 반영(초기 로딩 시)
  if (accessToken.value) {
    api.defaults.headers.common['Authorization'] = `Bearer ${accessToken.value}`
  } else {
    delete api.defaults.headers.common['Authorization']
  }

  // Getters
  const isAuthenticated = computed(() => !!accessToken.value) 
  const getToken        = computed(() => accessToken.value)
  const getUser         = computed(() => user.value)

  // Actions
  const setToken = (token) => {
    accessToken.value = token
    if (token) {
      localStorage.setItem('accessToken', token) 
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      localStorage.removeItem('accessToken') 
      delete api.defaults.headers.common['Authorization']
    }
  }

  const setUser = (userData) => {
    user.value = userData
  }

  const clearAuth = () => {
    setToken(null)      // token/헤더/localStorage 정리까지 같이
    user.value = null
  }

  // 로그인
  const login = async (credentials) => {
    try {
      const res  = await api.post(urls.login.login, credentials)
      const data = res.data

      let error = ''

      if (data.token) {
        setToken(data.token)
        setUser(data.user)
      } else {
        error = data.error || '아이디 또는 비밀번호가 올바르지 않습니다.'
      }

      return {
        error,
        status: data.status,
        refreshToken: data.refreshToken
      }
    } catch (err) {
      console.error('Login error:', err)
      return {
        error: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
        status: 'error'
      }
    }
  }

  // 로그아웃
  const logout = async () => {
    try {
      localStorage.setItem('preventAutoLogin', 'true')
      await api.post(urls.login.logout) 
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      clearAuth()
      router.push('/')
    }
  }

  // user 상태 확인
  const userInfo = async () => {
    try {
      const res  = await api.post(urls.login.userInfo)
      const data = res.data

      if (data.token) {
        setToken(data.token)
        setUser(data.user)
        return true
      }
      return false
    } catch (err) {
      clearAuth()
      return false
    }
  }

  const refreshAccessToken = async (params) => {
    try {
      const res  = await api.post(urls.login.refresh, params)
      const data = res.data

      if (data.token) {
        setToken(data.token)
        setUser(data.user)
        return true
      }
      return false
    } catch (err) {
      clearAuth()
      return false
    }
  }

  return {
    // State
    accessToken,
    user,

    // Getters
    isAuthenticated,
    getToken,
    getUser,

    // Actions
    setToken,
    setUser,
    clearAuth,
    login,
    logout,
    userInfo,
    refreshAccessToken
  }
})